import React from 'react';
import { Grid, Stack, Typography } from 'components/ui';
import { useNavigate } from 'react-router-dom';
import { InspectionSubjectLink } from 'utils/link';
import { IndexListItemButton } from 'components/styles_components/list';
import { FormattedMessage } from 'react-intl';
import InspectionSubject from 'utils/inspection_subject';
import useMobile from 'hooks/use_mobile';

const ListItem = ({ inspectionSubject }) => {
  const navigate = useNavigate();
  const inspectionSubjectUtil = InspectionSubject(inspectionSubject);
  const isMobile = useMobile();
  const nameGridWidth = isMobile ? 12 : 6;

  return (
    <IndexListItemButton
      className={inspectionSubjectUtil.htmlClass}
      onClick={() => {
        navigate(InspectionSubjectLink(inspectionSubject.id));
      }}
    >
      <Grid container justifyContent="center" alignItems="center" spacing={2}>
        <Grid size={{ xs: nameGridWidth }}>
          <Stack>
            <Typography variant="button">{inspectionSubject.name}</Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              <FormattedMessage id="place" />: {inspectionSubject.place.name}
            </Typography>
          </Stack>
        </Grid>
        {!isMobile && (
          <>
            <Grid textAlign="center" size={{ xs: 2 }}>
              {inspectionSubject.serialNumber || '-'}
            </Grid>
            <Grid textAlign="center" size={{ xs: 2 }}>
              <Typography color={inspectionSubjectUtil.incomingInspectionsColor} variant="button">
                {inspectionSubject.incomingInspectionsTotal}
              </Typography>
            </Grid>
            <Grid textAlign="center" size={{ xs: 2 }}>
              <Typography color={inspectionSubjectUtil.overdueInspectionsColor} variant="button">
                {inspectionSubject.overdueInspectionsTotal}
              </Typography>
            </Grid>
          </>
        )}
      </Grid>
    </IndexListItemButton>
  );
};

export default ListItem;
